import * as React from "react";
import { CountDownBox, Time, CountDIcon } from "./styled";

import { PoolExtraFlashInfo } from "../../../../services/product";
import { formatSecToDate } from "views/utils/flashProduct";

const CountDown = (props: {
	needIcon: boolean;
	countInfo: PoolExtraFlashInfo;
	style?: React.CSSProperties;
}) => {
	const { countInfo, style, needIcon = true } = props;
	const [endTime, setEndTime] = React.useState<number>(+(countInfo?.countdownToEnd || 0));

	const tick = () => {
		setEndTime((preTime) => {
			return preTime - 1;
		});
	};
	React.useEffect(() => {
		let timerID = setInterval(() => {
			if (endTime > 0) {
				tick();
			}
		}, 1000);
		return () => clearInterval(timerID);
	});

	if (!props?.countInfo?.countdownToEnd) {
		return null;
	}
	if (endTime <= 0) {
		return null;
	}
	return (
		<CountDownBox style={{ ...style }}>
			{needIcon && <CountDIcon className={countInfo?.uiOptions?.icon} />}
			<Time>{formatSecToDate(endTime)}</Time>
		</CountDownBox>
	);
};

export default CountDown;
